// extracted by mini-css-extract-plugin
export default {"button":"CheckoutButton_button__-y+4Q"};